import NewsBanner from './NewsBanner.container'

export default NewsBanner
